module.exports = __webpack_public_path__ + "img/no-product.8c96999e.png";